import { type AppDispatch, type RootState } from '../../../store'
import * as RegularKekService from '../services/regularKekService'
import * as RegularKekListByFilterParameteService from '../services/getRegularKekListByFilterParameter'
import { regularKekListLoadingAction, regularKekListUpdateAction, regularKekListErrorAction } from './RegularKekListSlice'
import * as getAllRegularKekFilterParameterService from '../services/getAllRegularKekFilterParameters'
import * as CreateRegularKekService from '../services/createRegularKek'
import * as regularKekHsmService from '../services/regularKekHsmService'
import { getAllRegularKekParameterDataLoading, getAllRegularKekParameterDataError, getAllRegularKekParameterData } from '../redux/getAllRegularKekFilterParameterSlice'
import {
  allTenantsLoadingAction,
  allTenantsUpdateAction,
  allTenantsErrorAction
} from './getAllTenantsSlice'
import * as AllTenantService from '../services/getAllTenantsService'
import { type CreateRegularKekPostRequest, type CreateMappingPostRequest, type CreateHybridKekPostRequest } from '../types'

import {
  createRegularKekErrorAction,
  createRegularKekLoadingAction,
  createRegularKekUpdateAction
} from './createRegularKekSlice'
import * as downloadregularKekService from '../services/downloadRegularKek'
import {
  downloadRegularKekByLabelErrorAction,
  downloadRegularKekByLabelLoadingAction, downloadRegularKekByLabelUpdateAction
} from './downloadRegularKekSlice'
import { regularKekHsmListErrorAction, regularKekHsmListLoadingAction, regularKekHsmListUpdateAction } from './regularKekHsmSlice'
import {
  regularKekHsmStatusErrorAction,
  regularKekHsmStatusLoadingAction,
  regularKekHsmStatusUpdateAction
} from './regularKekHsmStatusSlice'
import getHsmKeksRequestStatus, { type CryptoRequest, type HsmRegularKEKListDTO } from '../services/getHsmKeksRequestStatus'
import { getHSMRegularKekHsmList } from '../services/regularKekHsmService'
import { getRegularKekListHsmByFilterParameter } from '../services/getRegularKekListHsmByFilterParameter'
import { keyTypeMappingsListErrorAction, keyTypeMappingsListLoadingAction, keyTypeMappingsListUpdateAction } from './getActiveKeyTypeMappingsListSlice'
import { getActiveKeyTypeMappingsList } from '../services/getActiveKeyTypeMappingsList'
import * as deactivateKeyMappingService from '../services/deactivateKeyMapping'
import { deactivateKeyMappingLoading, deactivateKeyMappingSuccess, deactivateKeyMappingFailure } from './deactivateKeyMappingSlice'
import { type KeyTypeMappingRequest } from '../services/deactivateKeyMapping'
import { regularLabelsLoadingAction, regularLabelsUpdateAction, regularLabelsErrorAction } from './hybrid/getRegularLabelsSlice'
import * as getFilterTypesForKeyDeviceMappings from '../services/getFilterTypesForKeyDeviceMappings'
import { type CreateKeyMappingApiResponse } from '../services/createKeyMapping'
import { createKeyMappingLoadingAction, createKeyMappingUpdateAction, createKeyMappingErrorAction } from './createKeyMappingSlice'
import * as CreateKeyMappingService from '../services/createKeyMapping'
import { hsmKeyTypeMappingListLoadingAction, hsmKeyTypeMappingListUpdateAction, hsmKeyTypeMappingListErrorAction } from './getFilteredActiveDeviceKeyMappingList'
import * as FilteredActiveDeviceKeyMappingsListService from '../services/getFilteredActiveDeviceKeyMappingsList'
import * as FilteredInactiveDeviceKeyMappingsListService from '../services/getFilteredInactiveDeviceMappingList'
import { inactiveKeyTypeMappingsListErrorAction, inactiveKeyTypeMappingsListLoadingAction, inactiveKeyTypeMappingsListUpdateAction } from './getInactiveKeyTypeMappingsListSlice'
import * as InctiveKeyTypeMappingsListService from '../services/getInactiveKeyTypeMappingsList'
import {
  hybridKeksLabelsLoadingAction, hybridKeksLabelsUpdateAction, hybridKeksLabelsErrorAction
} from './getHybridKeksLabelsSlice'
import { getHybridKeksLabels } from '../services/getHybridKeksLabels'
import * as HybridKekService from '../services/hybrid/hybridKekService'
import * as HybridKekListByFilterParameterService from '../services/hybrid/getHybridKekListByFilterParameter'
import * as getAllUsersFilterParameterService from '../services/hybrid/getUsersFilterParameters'
import { getUsersDataLoading, getUsersDataError, getUsersData } from './hybrid/getAllUsersFilterParameterSlice'
import * as CreateHybridKekService from '../services/hybrid/createHybridKek'
import { createHybridKekLoadingAction, createHybridKekUpdateAction, createHybridKekErrorAction } from './hybrid/createHybridKekSlice'
import { getWrapRegularLabels } from '../services/hybrid/getRegularLabelsService'
import { getFilterTypesForDeviceKeyMappingsLoading, getFilterTypesForDeviceKeyMappingsData, getFilterTypesForDeviceKeyMappingsError } from './getFilterTypesForKeyDeviceMappingsSlice'
import {
  hybridKekListLoadingAction,
  hybridKekListUpdateAction,
  hybridKekListErrorAction
} from '../redux/hybrid/HybridKekListSlice'
import { exportSMimeCertificateLoadingAction, exportSMimeCertificateUpdateAction, exportSMimeCertificateErrorAction } from './exportSMimeCertificateSlice'
import * as exportSMimeCertificateService from '../services/exportSMimeCertificate'

export const fetchRegularKEKList = (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string
) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(regularKekListLoadingAction())

    void RegularKekService.getHSMRegularKekList(
      page, size, sortdir, sortfield, input,
      (regularKekList: RegularKekService.HSMRegularKekObj, httpStatus: number) => {
        dispatch(
          regularKekListUpdateAction({
            data: regularKekList,
            httpStatus
          })
        )
      },
      (errorMessage, httpStatus) => {
        dispatch(regularKekListErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const getAllRegularKekFilterParameterInfo = (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string,
  filterParams: any
) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(regularKekListLoadingAction())

  void RegularKekListByFilterParameteService.getAllHsmRegumarKekListFiltered(
    page, size, sortdir, sortfield, filterParams,
    (regularKekList: RegularKekListByFilterParameteService.HSMRegularKekObj, httpStatus: number) => {
      dispatch(
        regularKekListUpdateAction({
          data: regularKekList,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(regularKekListErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const getAllRegularKekParameterInfo = () => async (dispatch: any) => {
  dispatch(getAllRegularKekParameterDataLoading())
  void getAllRegularKekFilterParameterService.getAllRegularKekParameter((data: any, httpStatus: number) => {
    dispatch(getAllRegularKekParameterData({ data, httpStatus }))
  },
  (errorMessage: string, httpStatus: number) => {
    dispatch(getAllRegularKekParameterDataError({ errorMessage, httpStatus }))
  })
}

export const fetchTenants = () => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(allTenantsLoadingAction())

  void AllTenantService.getAllTenants(
    (tenants: string[], httpStatus: number) => {
      dispatch(
        allTenantsUpdateAction({
          data: tenants,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(allTenantsErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const createRegularKek = (createKekRequest: CreateRegularKekPostRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(createRegularKekLoadingAction())

  void CreateRegularKekService.createKek(
    createKekRequest,
    (createKekApiResponse: CreateRegularKekService.CreateGroupRegularKekApiResponse, httpStatus: number) => {
      dispatch(
        createRegularKekUpdateAction({
          data: createKekApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(createRegularKekErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const downloadregularKekByLabel = (label: string) => async (dispatch: any) => {
  dispatch(downloadRegularKekByLabelLoadingAction())
  try {
    await downloadregularKekService.downloadregularKekService(label, (message: any) => {
      dispatch(downloadRegularKekByLabelUpdateAction(message))
    },
    (errorMessage: any) => {
      dispatch(downloadRegularKekByLabelErrorAction(errorMessage))
    })
  } catch (e: any) {
    dispatch(downloadRegularKekByLabelErrorAction(e))
  }
}

export const fetchRegularKEKHsmList = (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string
) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(regularKekHsmListLoadingAction())

  await regularKekHsmService.getHSMRegularKekHsmList(
    page, size, sortdir, sortfield, input,
    (requestId: string, httpStatus: number) => {
      dispatch(
        regularKekHsmListUpdateAction({
          requestId,
          httpStatus
        })
      )
    },
    (errorMessage: any, httpStatus: any) => {
      dispatch(regularKekHsmListErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchHsmKeksRequestStatus = (requestId: string) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(regularKekHsmStatusLoadingAction())
  await getHsmKeksRequestStatus(
    requestId,
    (cryptoRequest: CryptoRequest, kekList?: HsmRegularKEKListDTO) => {
      dispatch(regularKekHsmStatusUpdateAction({
        cryptoRequest,
        httpStatus: 200,
        kekList
      }))
    },
    (errorMessage: string, httpStatus: number) => {
      dispatch(regularKekHsmStatusErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchRegularKekHsmListWithStatus = (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string
): ((dispatch: AppDispatch, getState: () => RootState) => Promise<void>) =>
  async (dispatch, getState) => {
    dispatch(regularKekHsmListLoadingAction())
    dispatch(regularKekHsmStatusLoadingAction())
    await getHSMRegularKekHsmList(
      page,
      size,
      sortdir,
      sortfield,
      input,
      (requestId: string, httpStatus: number) => {
        dispatch(regularKekHsmListUpdateAction({ requestId, httpStatus }))
        const pollStatus = async (): Promise<void> => {
          const poll = async (): Promise<void> => {
            await getHsmKeksRequestStatus(
              requestId,
              (cryptoRequest, kekList) => {
                if (cryptoRequest.requestStatus === 'DONE') {
                  dispatch(regularKekHsmStatusUpdateAction({
                    cryptoRequest,
                    httpStatus,
                    kekList
                  }))
                } else if (cryptoRequest.requestStatus === 'FAILED') {
                  dispatch(regularKekHsmStatusErrorAction({
                    errorMessage: 'Request failed',
                    httpStatus
                  }))
                } else {
                  setTimeout(() => { void poll() }, 2000)
                }
              },
              (errorMessage, status) => {
                dispatch(regularKekHsmStatusErrorAction({ errorMessage, httpStatus: status }))
              }
            )
          }
          void poll()
        }

        void pollStatus()
      },
      (errorMessage: string, httpStatus: number) => {
        dispatch(regularKekHsmListErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const fetchRegularKekHsmListWithStatusAndFilters = (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string,
  filterParams: any
): ((dispatch: AppDispatch, getState: () => RootState) => Promise<void>) =>
  async (dispatch, getState) => {
    dispatch(regularKekHsmListLoadingAction())
    dispatch(regularKekHsmStatusLoadingAction())

    await getRegularKekListHsmByFilterParameter(
      page,
      size,
      sortdir,
      sortfield,
      filterParams,
      (requestId: string, httpStatus: number) => {
        dispatch(regularKekHsmListUpdateAction({ requestId, httpStatus }))

        const pollStatus = async (): Promise<void> => {
          const poll = async (): Promise<void> => {
            await getHsmKeksRequestStatus(
              requestId,
              (cryptoRequest, kekList) => {
                if (cryptoRequest.requestStatus === 'DONE') {
                  dispatch(regularKekHsmStatusUpdateAction({
                    cryptoRequest,
                    httpStatus,
                    kekList
                  }))
                } else if (cryptoRequest.requestStatus === 'FAILED') {
                  dispatch(regularKekHsmStatusErrorAction({
                    errorMessage: 'Request failed',
                    httpStatus
                  }))
                } else {
                  setTimeout(() => { void poll() }, 2000)
                }
              },
              (errorMessage, status) => {
                dispatch(regularKekHsmStatusErrorAction({ errorMessage, httpStatus: status }))
              }
            )
          }
          void poll()
        }

        void pollStatus()
      },
      (errorMessage: string, httpStatus: number) => {
        dispatch(regularKekHsmListErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const fetchKeyTypeMappingsList = (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string
) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(keyTypeMappingsListLoadingAction())

    void getActiveKeyTypeMappingsList(
      page, size, sortdir, sortfield, input,
      (keyTypeMappingsList: any, httpStatus: number) => {
        dispatch(
          keyTypeMappingsListUpdateAction({
            data: keyTypeMappingsList,
            httpStatus
          })
        )
      },
      (errorMessage, httpStatus) => {
        dispatch(keyTypeMappingsListErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const fetchInactiveKeyTypeMappingsList = (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string
) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(inactiveKeyTypeMappingsListLoadingAction())

    void InctiveKeyTypeMappingsListService.getInactiveKeyTypeMappingsList(
      page, size, sortdir, sortfield, input,
      (keyTypeMappingsList: any, httpStatus: number) => {
        dispatch(
          inactiveKeyTypeMappingsListUpdateAction({
            data: keyTypeMappingsList,
            httpStatus
          })
        )
      },
      (errorMessage: string, httpStatus: number) => {
        dispatch(inactiveKeyTypeMappingsListErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const deactivateKeyMapping = (request: KeyTypeMappingRequest) => async (dispatch: any) => {
  dispatch(deactivateKeyMappingLoading())
  try {
    await deactivateKeyMappingService.deactivateKeyMappingService(
      request,
      (data: any, httpStatus: number) => {
        dispatch(deactivateKeyMappingSuccess({ data, httpStatus }))
      },
      (errorMessage: string, httpStatus: number) => {
        dispatch(deactivateKeyMappingFailure({ error: errorMessage, httpStatus }))
      }
    )
  } catch (e: any) {
    dispatch(deactivateKeyMappingFailure({ error: e.message ?? 'Unknown error', httpStatus: 500 }))
  }
}

export const fetchFilterTypesForKeyDeviceMappings = () => async (dispatch: any) => {
  dispatch(getFilterTypesForDeviceKeyMappingsLoading())
  void getFilterTypesForKeyDeviceMappings.getFilterTypesForDeviceKeyMappings((data: any, httpStatus: number) => {
    dispatch(getFilterTypesForDeviceKeyMappingsData({ data, httpStatus }))
  },
  (errorMessage: string, httpStatus: number) => {
    dispatch(getFilterTypesForDeviceKeyMappingsError({ errorMessage, httpStatus }))
  })
}

export const createNewDeviceKeyMapping = (createKekRequest: CreateMappingPostRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(createKeyMappingLoadingAction())

  void CreateKeyMappingService.createMapping(
    createKekRequest,
    (createKekApiResponse: CreateKeyMappingApiResponse, httpStatus: number) => {
      dispatch(
        createKeyMappingUpdateAction({
          data: createKekApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(createKeyMappingErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchFilteredActiveDeviceKeyMappingList = (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string,
  filterParams: any
) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(hsmKeyTypeMappingListLoadingAction())

  void FilteredActiveDeviceKeyMappingsListService.getFilteredActiveDeviceKeyMappingList(
    page, size, sortdir, sortfield, filterParams,
    (regularKekList: FilteredActiveDeviceKeyMappingsListService.HsmKeyTypeMappingObj, httpStatus: number) => {
      dispatch(
        hsmKeyTypeMappingListUpdateAction({
          data: regularKekList,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(hsmKeyTypeMappingListErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchFilteredInactiveDeviceKeyMappingList = (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string,
  filterParams: any
) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(hsmKeyTypeMappingListLoadingAction())

  void FilteredInactiveDeviceKeyMappingsListService.getFilteredInactiveDeviceKeyMappingList(
    page, size, sortdir, sortfield, filterParams,
    (regularKekList: FilteredInactiveDeviceKeyMappingsListService.HsmKeyTypeMappingObj, httpStatus: number) => {
      dispatch(
        hsmKeyTypeMappingListUpdateAction({
          data: regularKekList,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(hsmKeyTypeMappingListErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchHybridKeksLabels = (input: string) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(hybridKeksLabelsLoadingAction())
  void getHybridKeksLabels(input,
    (labels: string[], httpStatus: number) => {
      dispatch(hybridKeksLabelsUpdateAction({ data: labels, httpStatus }))
    },
    (errorMessage: string, httpStatus: number) => {
      dispatch(hybridKeksLabelsErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchHybridKEKList = (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string
) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(hybridKekListLoadingAction())

    void HybridKekService.getHybridKekList(
      page, size, sortdir, sortfield, input,
      (hybridKekList: HybridKekService.HybridKekObj, httpStatus: number) => {
        dispatch(
          hybridKekListUpdateAction({
            data: hybridKekList,
            httpStatus
          })
        )
      },
      (errorMessage, httpStatus) => {
        dispatch(hybridKekListErrorAction({ errorMessage, httpStatus }))
      }
    )
  }

export const getAllUsersFilterParameterInfo = (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string,
  filterParams: any
) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(hybridKekListLoadingAction())

  void HybridKekListByFilterParameterService.getAllHybridKekListFiltered(
    page, size, sortdir, sortfield, filterParams,
    (hybridKekList: HybridKekListByFilterParameterService.HybridKekObj, httpStatus: number) => {
      dispatch(
        hybridKekListUpdateAction({
          data: hybridKekList,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(hybridKekListErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const getUsersInfo = () => async (dispatch: any) => {
  dispatch(getUsersDataLoading())
  void getAllUsersFilterParameterService.getUsersParameter((data: any, httpStatus: number) => {
    dispatch(getUsersData({ data, httpStatus }))
  },
  (errorMessage: string, httpStatus: number) => {
    dispatch(getUsersDataError({ errorMessage, httpStatus }))
  })
}

export const createHybridKek = (createKekRequest: CreateHybridKekPostRequest) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(createHybridKekLoadingAction())

  void CreateHybridKekService.createHybridKek(
    createKekRequest,
    (createKekApiResponse: CreateHybridKekService.CreateGroupHybridKekApiResponse, httpStatus: number) => {
      dispatch(
        createHybridKekUpdateAction({
          data: createKekApiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(createHybridKekErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchWrapRegularKeks = () => async (dispatch: any) => {
  dispatch(regularLabelsLoadingAction())
  void getWrapRegularLabels((data: any, httpStatus: number) => {
    dispatch(regularLabelsUpdateAction({ data, httpStatus }))
  },
  (errorMessage: string, httpStatus: number) => {
    dispatch(regularLabelsErrorAction({ errorMessage, httpStatus }))
  })
}

export const exportSMimeCertificate = (label: string) => async (dispatch: any) => {
  dispatch(exportSMimeCertificateLoadingAction())
  try {
    await exportSMimeCertificateService.exportSMimeCertificateService(label, (message: any) => {
      dispatch(exportSMimeCertificateUpdateAction(message))
    },
    (errorMessage: any) => {
      dispatch(exportSMimeCertificateErrorAction(String(errorMessage ?? '')))
    })
  } catch (e: any) {
    dispatch(exportSMimeCertificateErrorAction(e?.message ?? String(e)))
  }
}
